export function Divider() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="603"
      height="11"
      viewBox="0 0 603 11"
      fill="none"
    >
      <path
        d="M0.150391 0.581055V10.5811H602.15V7.29158L0.150391 0.581055Z"
        fill="#363636"
      />
    </svg>
  )
}
